function ShopperMarketingService(Restangular) {
	this.api = Restangular.one('Shopper');
}

ShopperMarketingService.prototype.getShopperMarketingInfo = function () {
	return this.api.one('ShopperMarketingInformation').get();
};

ShopperMarketingService.prototype.updateShopperMarketingInfo = function (request) {
    return this.api.post('ShopperMarketingInformation', request);
};

module.exports = ShopperMarketingService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/myaccount/components/myaccount/shopper-marketing-service.js
 **/